<template>
  <Form ref="newForm" class="modalFormWrap formStyle" :model="newInfo" :rules="rules">
    <Row :gutter="30">
      <Col span="12">
        <FormItem prop="sex" label="性别">
          <Select v-model="newInfo.sex" placeholder="">
            <Option value="男">男</Option>
            <Option value="女">女</Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="birthDay" label="生日(不可修改)">
          <Input type="text" v-model="newInfo.birthDay" :readonly="userInfo.accountType=='DESIGNER'" :disabled="userInfo.accountType=='DESIGNER'"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="nation" label="民族">
          <Select v-model="newInfo.nation" placeholder="" filterable>
            <Option v-for="(n, i) in nations" :key="i" :value="n">{{n}}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="30">
      <Col span="12" class="bdTop">
        <FormItem prop="address" label="通讯地址">
          <Input type="text" v-model="newInfo.address"></Input>
        </FormItem>
      </Col>
      <Col span="12" class="bdTop">
        <FormItem prop="email" label="电子邮箱">
          <Input type="email" v-model="newInfo.email"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="phone" label="联系电话">
          <Input type="tel" v-model="newInfo.mobilePhone" readonly disabled></Input>
        </FormItem>
        <span class="addText" @click="addPhone">添加</span>
        <div v-if="phoneList.length>0">
          <p v-for="(n, i) in phoneList" :key="i" class="phoneWrap">
            <span class="delText" @click="delPhone(i)">删除</span>
            <Input type="tel" v-model="n.phone"></Input>
          </p>
        </div>
      </Col>
      <Col span="12">
        <FormItem prop="website" label="主页/官网">
          <Input type="url" v-model="newInfo.website"></Input>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="30">
      <Col span="12">
        <FormItem prop="wechatSubscription" label="微信号/公众号">
          <Input type="text" v-model="newInfo.wechatSubscription"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="weibo" label="微博">
          <Input type="text" v-model="newInfo.weibo"></Input>
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem prop="video" label="视频">
          <Input type="text" v-model="newInfo.video"></Input>
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem prop="description" label="个人简介/理念（1000字以内）">
          <Input type="textarea" :autosize="{minRows: 4}" v-model="newInfo.description"></Input>
        </FormItem>
      </Col>
    </Row>
    <div class="btnWrap">
      <Button class="defaultBtn formBtn" shape="circle" :loading="submitting" @click="submit">保存并跳转至下一未填项</Button>
      <Button type="text" class="rightBtn" @click="skip">跳过此页</Button>
    </div>
  </Form>
</template>
<script>
import personalService from '@/api/personal'
export default {
  props: ['info'],
  data(){
    return{
      newInfo: {},
      rules: {
        sex: [{required: true, message: "请选择性别", trigger: 'blur,change'}],
        birthDay: [{required: true, message: "请选择日期", trigger: 'blur,change'}],
        nation: [{required: true, message: "请输入民族", trigger: 'blur,change'}],
        address: [{required: true, message: "请输入通讯地址", trigger: 'blur,change'}],
        email: [{
          required: true, 
          message: "请输入正确的电子邮箱", 
          pattern: /[\w]+(\.[\w]+)*@[\w]+(\.[\w])+/, 
          trigger: 'blur,change'
        }],
        // website: [{required: true, message: "请输入主页/官网链接", trigger: 'blur,change'}],
        // wechatSubscription: [{required: true, message: "请输入微信公众号", trigger: 'blur,change'}],
        // weibo: [{required: true, message: "请输入微博号", trigger: 'blur,change'}],
        // video: [{required: true, message: "请输入视频链接", trigger: 'blur,change'}],
        description: [{required: false, message: "1000字以内", trigger: 'blur,change', max: 1000}]
      },
      submitting: false,
      userInfo: {},
      phoneList: [],
      nations: ["汉族","壮族","回族","满族","维吾尔族","苗族","彝族","土家族","藏族","蒙古族","侗族","布依族","瑶族","白族","朝鲜族","哈尼族","黎族","哈萨克族","傣族","畲族","傈僳族","东乡族","仡佬族","拉祜族","佤族","水族","纳西族","羌族","土族","仫佬族","锡伯族","柯尔克孜族","景颇族","达斡尔族","撒拉族","布朗族","毛南族","塔吉克族","普米族","阿昌族","怒族","鄂温克族","京族","基诺族","德昂族","保安族","俄罗斯族","裕固族","乌孜别克族","门巴族","鄂伦春族","独龙族","赫哲族","高山族","珞巴族","塔塔尔族"]
      // nations: ["阿昌族","白族","保安族","布朗族","布依族","朝鲜族","达斡尔族","傣族","德昂族","东乡族","侗族","独龙族","俄罗斯族","鄂伦春族","鄂温克族","高山族","仡佬族","哈尼族","哈萨克族","汉族","赫哲族","回族","基诺族","京族","景颇族","柯尔克孜族","拉祜族","黎族","傈僳族","珞巴族","满族","毛南族","门巴族","蒙古族","苗族","仫佬族","纳西族","怒族","普米族","羌族","撒拉族","畲族","水族","塔吉克族","塔塔尔族","土家族","土族","佤族","维吾尔族","乌孜别克族","锡伯族","瑶族","彝族","裕固族","藏族","壮族"]
    }
  },
  mounted(){
    this.newInfo = Object.assign({}, this.info)
    this.userInfo = JSON.parse(JSON.stringify(this.$store.getters.userInfo))
    this.phoneList = this.userInfo.phone || []
    this.phoneList.splice(0, 1)
    if(this.userInfo.accountType=='DESIGNER'){
      let idNumber = this.userInfo.idNumber
      this.newInfo.birthDay = `${idNumber.substring(6, 10)}-${idNumber.substring(10, 12)}-${idNumber.substring(12, 14)}`
    }
    this.newInfo.mobilePhone = this.userInfo.mobilePhone
  },
  methods:{
    // 添加电话
    addPhone(){
      this.phoneList.push({})
    },
    // 删除电话
    delPhone(i){
      this.phoneList.splice(i,1)
    },
    submit(){
      this.$refs.newForm.validate(valid => {
        if (valid) {
          this.submitting = true
          let condition = Object.assign({}, this.newInfo), 
              open = this.userInfo.phoneOpen,
              phone = [{phone: this.newInfo.mobilePhone, open}]
          for(let i=0, l=this.phoneList.length;i<l;i++){
            let temp = this.phoneList[i].phone
            if(temp){
              phone.push({phone: temp, open})
            }
          }
          condition.phone = phone
          personalService.updateBasicInfo(condition)
          .then(res => {
            if(res.errorNo==0){
              let userInfo = Object.assign({}, this.userInfo, condition)
              this.$store.commit('setUserInfo', userInfo)
              this.skip()
            }else{
              this.$Message.error(res.errorMessage)
            }
            this.submitting = false
          }).catch(err => {
            this.submitting = false
            // this.$Message.error(err.message)
            console.log(err.message)
            this.$Message.error('连接服务器失败，请稍后再试')
          })
        }else{
          this.$Message.error('信息未正确填写完整')
        }
      })
    },
    skip(){
      this.$emit('Skip', {key: 'basicInfo'})
    }
  }
}
</script>